import { useQuery } from '@tanstack/react-query';
import apiSDK from '@/services/apiSdk';
import { ParamsStoreManagement } from './types';

export const QUERY_STORE_MANAGEMENT = 'QUERY_STORE_MANAGEMENT';

export function useStoreManagement(
    params?: ParamsStoreManagement,
    enable = true,
) {
    const getAllStoreManagement = async () => {
        const response = await apiSDK.store.management({
            ...params,
        });

        return response;
    };

    return useQuery([QUERY_STORE_MANAGEMENT, params], getAllStoreManagement, {
        retry: false,
        refetchOnWindowFocus: false,
        enabled: !!enable,
    });
}
